import { useQuery } from "@apollo/client";
import { useNavigate } from "react-router-dom";

import GET_OUTGOING_TRAINEESHIP_LISTING from "../../../graphql/queries/traineeships/getOutgoingTraineeshipListing";
import GET_COUNTRIES from "../../../graphql/queries/registration/getCountries";
import GET_TR_COUNT from "../../../graphql/queries/traineeships/getTrCount";

import CustomTable from "../../../components/Table";
import TableSkeleton from "../../../components/Table/components/TableSkeleton";
import Filters from "../../../components/Filters";

import { useEffect, useState } from "react";
import { useTraineeshipsFilters } from "./hooks/useTraineeshipsFilters";

import { useTranslation } from "react-i18next";

// fallback state
export const defaultState = {
  status: "",
  studentFirstName: "",
  studentLastName: "",
  sendingErasmusCode: "",
  sendingCountry: [],
  createdByStudent: "",
  iscedId: "",
  traineeshipId: "",
  receivingOrganization: "",
  receivingCountry: "",
  sendingContactFirstName: "",
  sendingContactLastName: "",
  selectedFiltersList:[],
  sortBy:"",
  expandFilters: false
}

const OutgoingTraineeshipsList = ({ userHeiID }) => {
  const initialState = {
    status: "",
    studentFirstName: "",
    studentLastName: "",
    sendingErasmusCode: "",
    sendingCountry: [],
    createdByStudent: "",
    iscedId: "",
    traineeshipId: "",
    receivingOrganization: "",
    receivingCountry: "",
    sendingContactFirstName: "",
    sendingContactLastName: "",
    sortBy: localStorage.getItem('sortByTraineeships') !== null ? JSON.parse(localStorage.getItem('sortByTraineeships')) : "changed_descending",
    selectedFiltersList: localStorage.getItem('selectedFiltersTraineeship') !== null ? JSON.parse(localStorage.getItem('selectedFiltersTraineeship')) : {
      status: "",
      studentFirstName: "",
      studentLastName: "",
      sendingErasmusCode: "",
      sendingCountry: [],
      createdByStudent: "",
      iscedId: "",
      traineeshipId: "",
      receivingOrganization: "",
      receivingCountry: "",
      sendingContactFirstName: "",
      sendingContactLastName: "",
    },
  };

  const filters = useTraineeshipsFilters(initialState);
  const {
    state,
    setSelectedFiltersList,
    setExpandFilters,
    setSortBy,
    updateMultipleValues,
  } = filters;
  const {
    status,
    studentFirstName,
    studentLastName,
    sendingErasmusCode,
    sendingCountry,
    createdByStudent,
    iscedId,
    traineeshipId,
    receivingOrganization,
    receivingCountry,
    sendingContactFirstName,
    sendingContactLastName,
    selectedFiltersList,
    sortBy,
    expandFilters,
  } = state;
  const [page, setPage] = useState(localStorage.getItem('pageTraineeships') !== null ? parseInt(JSON.parse(localStorage.getItem('pageTraineeships'))) : 0);
  const navigate = useNavigate();

  const { t } = useTranslation();

  const getCreatedByFilter = () => {
    if (createdByStudent === "Created by Student") {
      return true;
    } else if (createdByStudent === "Created by Institution") {
      return false;
    } else {
      return undefined;
    }
  };

  const getCreatedByFilterForTrCount = () => {
    if (createdByStudent === "Created by Student") {
      return "student";
    } else if (createdByStudent === "Created by Institution") {
      return "dashboard";
    } else {
      return undefined;
    }
  };

  const {
    loading: traineeshipListingLoading,
    error: traineeshipListingError,
    data: traineeshipListingData,
    refetch: traineeshipListingRefetch,
  } = useQuery(GET_OUTGOING_TRAINEESHIP_LISTING, {
    variables: {
      page: page,
      sortBy: sortBy,
      optionalTrFilters: {
        status: status,
        studentFirstName: studentFirstName,
        studentLastName: studentLastName,
        sendingErasmusCode: sendingErasmusCode,
        sendingCountry: sendingCountry,
        createdByStudent: getCreatedByFilter(),
        iscedId: iscedId,
        traineeshipId: traineeshipId,
        receivingOrganization: receivingOrganization,
        receivingCountry: receivingCountry,
        sendingContactFirstName: sendingContactFirstName,
        sendingContactLastName: sendingContactLastName
      },
    },
    fetchPolicy: "cache-and-network",
  });

  const {
    loading: trCountLoading,
    error: trCountError,
    data: trCount,
    refetch: trCountRefetch,
  } = useQuery(GET_TR_COUNT, {
    variables: {
      sendingHeiID: userHeiID,
      status: status,
      studentFirstName: studentFirstName,
      studentLastName: studentLastName,
      sendingErasmusCode: sendingErasmusCode,
      createdBy: getCreatedByFilterForTrCount(),
      sendingCountry: sendingCountry,
      iscedId: iscedId,
      traineeshipId: traineeshipId,
      receivingOrganization: receivingOrganization,
      receivingCountry: receivingCountry,
      sendingContactFirstName: sendingContactFirstName,
      sendingContactLastName: sendingContactLastName
    },
    fetchPolicy: "cache-and-network",
  });

  const {
    loading: loadingCountries,
    error: errorCountries,
    data: dataCountries,
  } = useQuery(GET_COUNTRIES);

  const handleExpand = (value) => {
    setExpandFilters(value);
  };

  useEffect(() => {
    const data = localStorage.getItem('selectedFiltersTraineeship');

    if (data) {
      if (!Object.values(JSON.parse(data) || {})?.every(x => x === '' || (Array.isArray(x) && x.length === 0))) {
        setSelectedFiltersList(JSON.parse(data));
        traineeshipListingRefetch();
        trCountRefetch();
      }
    }
  }, []);

  useEffect(() => {
    page !== null && localStorage.setItem('pageTraineeships', JSON.stringify(page));
  }, [page]);

  useEffect(() => {
    localStorage.setItem('selectedFiltersTraineeship', JSON.stringify(selectedFiltersList));
  }, [selectedFiltersList]);

  useEffect(() => {
    sortBy !== null && localStorage.setItem('sortByTraineeships', JSON.stringify(sortBy));
  }, [sortBy]);

  useEffect(() => {
    updateMultipleValues(selectedFiltersList);
    traineeshipListingRefetch();
    trCountRefetch();
  }, [
    selectedFiltersList,
    updateMultipleValues,
    traineeshipListingRefetch,
    trCountRefetch,
  ]);

  const handleRemoveFilter = (filter, value) => {
    if (filter === "sendingCountry") {
      let temp = Object.assign({}, selectedFiltersList);
      temp[filter] = temp[filter].filter((i) => i !== value);
      setSelectedFiltersList(temp);
    } else {
      let temp = Object.assign({}, selectedFiltersList);
      temp[filter] = "";
      setSelectedFiltersList(temp);
    }
  };

  const formatDate = (string) => {
    var options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(string).toLocaleDateString("en-UK", options);
  }

  if (traineeshipListingLoading || loadingCountries || trCountLoading) {
    return (
      <TableSkeleton
        columnsPerFieldMap={{
          id_: "col-1",
          name: "col-1",
          receiving_organization: "col-1",
          receiving_organization_country: "col-1",
          sending_contact_person_: "col-1",
          isced_: "col-1",
          planned_period_: "col-1",
          status: "col-1",
        }}
      />
    );
  }

  if (traineeshipListingError || errorCountries || trCountError)
    return (
      <div className="text-center text-danger mx-auto">{t('errorMessage')}</div>
    );

  return (
    <main className="h-auto text-center mt-4">
      <CustomTable
        data={traineeshipListingData.traineeships.traineeshipList.map(
          ({
            traineeshipID,
            traineeship_id,
            field_tr_student_firstname,
            field_tr_student_lastname,
            receiving_organization,
            receiving_organization_country,
            sending_contact_person_firstname,
            sending_contact_person_lastname,
            field_of_education,
            planned_period_start_date,
            planned_period_end_date,
            field_tr_status,
          }) => {
            // Concatenate contact person name
            const contactPersonName = `${sending_contact_person_firstname} ${sending_contact_person_lastname}`;
            
            // Format and concatenate planned period dates
            const formattedPeriod = `${formatDate(planned_period_start_date)} - ${formatDate(planned_period_end_date)}`;

            return {
              id: traineeshipID,
              id_: traineeship_id,
              name: `${field_tr_student_firstname} ${field_tr_student_lastname}`,
              receiving_organisation: receiving_organization,
              receiving_organisation_country: receiving_organization_country,
              sending_contact_person_: contactPersonName,
              isced_: field_of_education,
              planned_period_: formattedPeriod,
              status: field_tr_status,
            };
          }
        )}
        page={page}
        setPage={(p) => setPage(p)}
        type={"traineeship-typeOfStudent-1-"}
        expandFilters={expandFilters}
        setExpandFilters={(e) => setExpandFilters(e)}
        filters={selectedFiltersList}
        setFilters={(filter, value) => { handleRemoveFilter(filter, value); setPage(0); }}
        sortBy={sortBy}
        setSortBy={() => setSortBy("")}
        columnsPerFieldMap={{
          id_: "col-1",
          name: "col-1",
          receiving_organisation: "col-1",
          receiving_organisation_country: "col-1",
          sending_contact_person_: "col-1",
          isced_: "col-1",
          planned_period_: "col-1",
          status: "col-1",
        }}
        pageLimit={30}
        totalCount={trCount?.traineeshipCount}
        hasPagination={true}
        hasFilters={true}
        onClickHandlers={traineeshipListingData.traineeships.traineeshipList.map(
          ({ traineeshipID }) =>
            (e) => {
              navigate("/traineeships/outgoing/" + traineeshipID);
            }
        )}
      />
      <Filters
        expand={expandFilters}
        handleExpand={handleExpand}
        selectedFiltersList={selectedFiltersList}
        setSelectedFiltersList={(e) => { setSelectedFiltersList(e); setPage(0); }}
        sortBy={sortBy}
        setSortBy={(e) => setSortBy(e)}
        countries={dataCountries?.countries}
        type={"traineeship"}
      />
    </main>
  );
};

export default OutgoingTraineeshipsList;
